import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SessionInactivityModalComponent } from '../session-inactivity-modal/session-inactivity-modal.component';
import { ConstantHandler } from '../../handlers/constant-handler';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/auth/services/auth.service';
import { GlobalService } from '../../services/global.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PrivacyStatementModalComponent } from '../privacy-statement-modal/privacy-statement-modal.component';
import { BreadcrumbService, Breadcrumb } from '../../services/breadcrumb.service';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  isPopupActive: boolean = false;
  breadcrumbItems: Breadcrumb[] = [];

  constructor(private userIdle: UserIdleService,
    private dialog: MatDialog,
    public globalService: GlobalService,
    private authService: AuthService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.breadcrumbs$.subscribe(items => {
      this.breadcrumbItems = items;
    });
  }

  // use global params to set these timers.
  private timeout: number = 3600; // 10 seconds
  private idle: number = 3600; // 30 minutes
  private subscriptions = new Subscription();

  ngOnInit() {
    if (!environment.ssoEnabled && !environment.msalEnabled) {
      this.initialize();
    }
    if (this.globalService.globalParams && this.globalService.globalParams.privacy_enabled && this.globalService.globalParams.privacy_enabled === 'true') {
      if (!this.globalService.user.privacy_accepted && this.globalService.getLocalStorageItem('PRIVACY_ACCEPTED_UPDATED') == null) {
      }
    }
  }

  private initialize() {
    this.userIdle.setConfigValues({ idle: this.idle, timeout: this.timeout, ping: 0 });

    // Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.subscriptions.add(this.userIdle.onTimerStart().subscribe((count) => this.checkForInactivity(count)));
  }

  ngOnDestroy() {
    if (!environment.ssoEnabled) {
      this.dialog.closeAll();
      this.userIdle.stopTimer();
      this.userIdle.stopWatching();
      this.subscriptions.unsubscribe();
    }
  }

  private checkForInactivity(count: number) {
    if (count >= 1 && !this.isPopupActive) {
      this.openSessionInactivityPopup(count);
      this.isPopupActive = true;
    }
  }

  private openSessionInactivityPopup(count: number) {
    const dialogRef = this.dialog.open(SessionInactivityModalComponent, {
      disableClose: true,
      closeOnNavigation: true,
      position: ConstantHandler.commonDialogPosition,
      width: '300px',
      height: '280px',
      data: {
        timeout: this.timeout,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Logout after the inactivity.
      if (result && result.event == 'Cancel') {
        // dont do anything
        this.userIdle.resetTimer();
        this.isPopupActive = false;
      } else {
        this.userIdle.resetTimer();
        this.userIdle.stopTimer();
        this.userIdle.stopWatching();
        this.isPopupActive = false;
        this.logout();
      }
    });
  }

  logout() {
    this.spinner.show();
    this.authService.logout({}).subscribe(
      (result) => {
        this.spinner.hide();
        if (result && result.response == 'SUCCESS') {
          if (environment.msalEnabled) {
            this.globalService.deleteUserSession();
            this.router.navigate(['auth/msl-logout']);
          } else if (environment.enabledBaseHref) {
            this.globalService.deleteUserSession();
            window.location.replace(window.location.origin);
          } else {
            this.router.navigate(['auth/login']);
            this.globalService.deleteUserSession();
          }
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  public navigateToHome() {
    if (window.location.hostname === 'localhost') this.router.navigate(['/app']);
    else window.location.href = 'https://victoraauto-asterisksc-uat-landing.ey.com';
  }

  @HostListener('window:beforeunload')
  unloadHandler(event) {
    console.log('Closing the Tab/Browser now');
  }
}
